// useScreenPermissions.js
import { useState, useEffect } from 'react';
import { screenRoutes } from './ScreenRoutes';

const API_URL = '/api';

export const useScreenPermissions = () => {
  const [screens, setScreens] = useState([]);
  const [hasFullAccess, setHasFullAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // useScreenPermissions.js
useEffect(() => {
  const fetchScreenPermissions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      const response = await fetch(`${API_URL}/user-accessible-screens`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch screen permissions');
      }

      const data = await response.json();
      console.log('Permission data received:', data);
      data.screens.forEach(screen => {
      console.log(`Screen code: ${screen.ScreenCode}, Route: ${screenRoutes[screen.ScreenCode]}`);
    });
      // Add route information to each screen
      const screensWithRoutes = data.screens.map(screen => ({
        ...screen,
        route: screenRoutes[screen.ScreenCode] || null
      }));
      
      console.log('Screens with routes:', screensWithRoutes);
      setScreens(screensWithRoutes);
      setHasFullAccess(data.hasFullAccess);
      console.log('Set hasFullAccess to:', data.hasFullAccess);
    } catch (err) {
      console.error('Error in useScreenPermissions:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchScreenPermissions();
}, []);

  // Check if user has permission for a specific screen and action
const hasPermission = (screenCode, action = 'CanView') => {
  console.log(`Checking permission for screen: ${screenCode}, action: ${action}`);
  console.log(`hasFullAccess: ${hasFullAccess}`);
  
  if (hasFullAccess) {
    console.log(`User has full access, granting permission for ${screenCode}`);
    return true;
  }
  
  const screen = screens.find(s => s.ScreenCode === screenCode);
  if (!screen) {
    console.log(`Screen not found for code: ${screenCode}`);
    return false;
  }
  
  // Handle both ScreenAccess and action permissions
  const hasPerm = screen[action] || false;
  console.log(`Permission result for ${screenCode}.${action}: ${hasPerm}`);
  return hasPerm;
};

  // Check if user has permission for a specific route
  const hasRoutePermission = (route, action = 'CanView') => {
    if (hasFullAccess) return true;
    
    const screen = screens.find(s => s.route === route);
    if (!screen) return false;
    
    return screen[action] || false;
  };

  // Get all screens the user has view access to
// Get all screens the user has access to (for sidebar)
const getAccessibleScreens = () => {
  if (hasFullAccess) return screens; // All screens
  
  // Use ScreenAccess instead of CanView
  return screens.filter(screen => screen.ScreenAccess);
};

  // Get accessible routes for navigation
  const getAccessibleRoutes = () => {
    const accessibleScreens = getAccessibleScreens();
    return accessibleScreens.map(screen => screen.route).filter(route => route !== null);
  };

  const hasScreenAccess = (screenCode) => {
  if (hasFullAccess) return true;
  
  const screen = screens.find(s => s.ScreenCode === screenCode);
  if (!screen) return false;
  
  return screen.ScreenAccess || false;
};

  return { 
    screens, 
    hasFullAccess, 
    loading, 
    error, 
    hasPermission,
    hasScreenAccess,
    hasRoutePermission,
    getAccessibleScreens,
    getAccessibleRoutes
  };
};